import React, { Component } from 'react'
import { app } from '../../base';
import { Redirect } from 'react-router-dom';

const loginStyles = {
  width: "90%",
  maxWidth: "315px",
  margin: "20px auto",
  border: "1px solid #ddd",
  borderRadius: "5px",
  padding: "10px"
}

class AdminLogin extends Component {
    constructor(props) {
        super(props);
        this.authWithEmailPassword = this.authWithEmailPassword.bind(this)

        this.state = {
          redirect: false
        };
    }

    authWithEmailPassword(event) {
    event.preventDefault()

    const email = this.emailInput.value
    const password = this.passwordInput.value

    app.auth().fetchProvidersForEmail(email)
      .then((providers) => {
        if (providers.indexOf("password") === -1) {
          // they used facebook
          this.loginForm.reset()
          alert("Try alternative login.");
        } else {
          // sign user in
          return app.auth().signInWithEmailAndPassword(email, password)
        }
      }, this)
      .then((user) => {
        if (user && user.email) {
          this.loginForm.reset()
          this.props.setCurrentUser(user)
          this.setState({redirect: true})
        }
      })
      .catch((error) => {
        alert(error.message);
      })
  }

    render() {
      if (this.state.redirect === true) {
        return <Redirect to="/admin/home" />
      }
        return (
            <div align="center">
              <h1>Admin Login</h1>
              <div style={loginStyles}>
                <form onSubmit={(event) => { this.authWithEmailPassword(event) }} ref={(form) => { this.loginForm = form }}>
                    <label className="pt-label">
                      <input style={{width: "100%"}} className="pt-input" name="email" type="email" ref={(input) => { this.emailInput = input }} placeholder="Email"></input>
                    </label>
                    <label className="pt-label">
                      <input style={{width: "100%"}} className="pt-input" name="password" type="password" ref={(input) => { this.passwordInput = input }} placeholder="Password"></input>
                    </label>
                    <input style={{width: "100%"}} type="submit" className="pt-button pt-intent-primary" value="Log In"></input>
                  </form>
              </div>
            </div>
        );
    }
}

export default AdminLogin



// WEBPACK FOOTER //
// ./src/components/admin/AdminLogin.js